const wxLogin = function(){			
		let APPID="wxbba0c73680edbbc2"//测试
		var url=encodeURIComponent("https://kfgroup.sxgongqiu.com/#/weChat") //测试
		
		// let APPID="wxc4cc61ee57c09f3e"
		// var url=encodeURIComponent("https://group.sxgongqiu.com/#/weChat")
		
		let REDIRECT_URL=url
	    let SCOPE="snsapi_userinfo"
		location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+APPID+"&redirect_uri="+REDIRECT_URL+"&response_type=code&scope="+SCOPE+"&state=STATE#wechat_redirect"						
}
export default wxLogin